import { lazy, Suspense, useEffect } from "react";
import { Route, Routes, useLocation, useParams } from "react-router-dom";
import { Cotizador as MultiCotizador } from "../../Pages/Multicotizador/Cotizador"
import { RubroOCompania } from "./RubroOCompania";
import { Pymes } from "../../Pages/Landings/Pages/Pymes";
import { Art } from "../../Pages/Landings/Pages/Art";
import { Caucion } from "../../Pages/Landings/Pages/Caucion";
import { Home } from "../../Pages/Landings/Pages/Home";
import { Contacto } from "../../Pages/Landings/Pages/Contacto";
import { Sustentabilidad } from "../../Pages/Landings/Pages/Sustentabilidad";
import { QuienesSomos } from "../../Pages/Landings/Pages/QuienesSomos";
import { OneTeam } from "../../Pages/Landings/Pages/OneTeam";
import { PoliticasPrivacidad } from "../../Pages/Landings/Pages/PoliticasPrivacidad";
import { IntegralComercio } from "../../Pages/Landings/Pages/IntegralComercio";
import { ResponsabilidadCivil } from "../../Pages/Landings/Pages/ResponsabilidadCivil";
import { FlotaVehiculos } from "../../Pages/Landings/Pages/FlotaVehiculos";
import { IncendioCorporativo } from "../../Pages/Landings/Pages/IncendioCorporativo";
import { MalaPraxis } from "../../Pages/Landings/Pages/MalaPraxis";
import { RCMedioambiental } from "../../Pages/Landings/Pages/RCMedioambiental";
import { TodoRiesgoCorporativo } from "../../Pages/Landings/Pages/TodoRiesgoCorporativo";
import { Construccion } from "../../Pages/Landings/Pages/Construccion";
import { Transporte } from "../../Pages/Landings/Pages/Transporte";
import { Consorcio } from "../../Pages/Landings/Pages/Consorcio";
import { Credito } from "../../Pages/Landings/Pages/Credito";
import { Agro } from "../../Pages/Landings/Pages/Agro";
import { VidaCorporativa } from "../../Pages/Landings/Pages/VidaCorporativa";
import { PreguntasFrecuentes } from "../../Pages/Landings/Pages/PreguntasFrecuentes";
import { FormularioArrepentimiento } from "../../Pages/Landings/Pages/FormularioArrepentimiento";
import { FormularioArrepentimientoEnviado } from "../../Pages/Landings/Pages/FormularioArrepentimientoEnviado";
import { Individuos } from "../../Pages/Landings/Pages/Individuos";
import { Auto } from "../../Pages/Landings/Pages/Auto";
import { Moto } from "../../Pages/Landings/Pages/Moto";
import { Prepaga } from "../../Pages/Landings/Pages/Prepaga";
import { Embarcaciones } from "../../Pages/Landings/Pages/Embarcaciones";
import { AP } from "../../Pages/Landings/Pages/AP";
import { Hogar } from "../../Pages/Landings/Pages/Hogar";
import { AsistenciaAlViajero } from "../../Pages/Landings/Pages/AsistenciaAlViajero";
import { Siniestros } from "../../Pages/Formularios/Siniestros/Siniestros";
import { APCorporativo } from "../../Pages/Landings/Pages/APCorporativo";
import { routes_arg } from "./ArgRouter";
import { routes_uy } from "./UYRouter";
import { useConfig } from "../../context/ConfigContext";
import { GarantiaAlquiler } from "../../Pages/Landings/Pages/GarantiaAlquiler";
import { NotFound } from "../../Pages/404/NotFound";
import WhatsAppFAB from "../../Pages/Landings/Components/WhatsAppFAB";
import { useCotizacionStore } from "../../Services/Providers/CotizacionStore";
import { esRecorridoDeVendedor } from "../../Services/ventaPresencial/rutaVendedor";

// Carga diferida: el link de WhatsApp a /gestion no baja el cotizador.
const GestionApp = lazy(() => import(/* webpackChunkName: "gestion" */ "../../Pages/Gestion/GestionApp"));
// Carga diferida: el link del mail de "retomá tu cotización".
const RetomarApp = lazy(() => import(/* webpackChunkName: "retomar" */ "../../Pages/Retomar/RetomarApp"));

const rutas_landing = [
  { path: "/seguros-corporativos", element: <Pymes /> },
  { path: "/seguros-corporativos-ART", element: <Art /> },
  { path: "/seguros-corporativos-integral-comercio", element: <IntegralComercio /> },
  { path: "/seguros-corporativos-caucion", element: <Caucion /> },
  { path: "/seguros-corporativos-RC", element: <ResponsabilidadCivil /> },
  { path: "/seguros-corporativos-flota", element: <FlotaVehiculos /> },
  { path: "/seguros-corporativos-incendio", element: <IncendioCorporativo /> },
  { path: "/seguros-corporativos-mala-praxis", element: <MalaPraxis /> },
  { path: "/seguros-corporativos-RC-medioambiental", element: <RCMedioambiental /> },
  { path: "/seguros-corporativos-construccion", element: <Construccion /> },
  { path: "/seguros-corporativos-transporte", element: <Transporte /> },
  { path: "/seguros-corporativos-consorcio", element: <Consorcio /> },
  { path: "/seguros-corporativos-credito", element: <Credito /> },
  { path: "/seguros-corporativos-agro", element: <Agro /> },
  { path: "/seguros-corporativos-vida", element: <VidaCorporativa /> },
  { path: "/seguros-corporativos-AP", element: <APCorporativo /> },
  { path: "/seguros-individuos", element: <Individuos /> },
  { path: "/seguros-individuos-auto", element: < Auto /> },
  { path: "/seguros-individuos-prepaga", element: <Prepaga /> },
  { path: "/seguros-individuos-moto", element: <Moto /> },
  { path: "/seguros-individuos-asistencia", element: <AsistenciaAlViajero /> },
  { path: "/seguros-individuos-hogar", element: <Hogar /> },
  { path: "/seguros-individuos-AP", element: <AP /> },
  { path: "/seguros-individuos-embarcacion", element: <Embarcaciones /> }
];

export const AppRouter = () => {

  const { config, origen } = useConfig()
  const location = useLocation();
  const esGestion = location.pathname.startsWith("/gestion");
  const landingUrlCotizacion = useCotizacionStore((s) => s.cotizacionValues.landingUrl);
  // Venta presencial: el asesor cotiza en persona; el WhatsApp público desviaría la consulta del registro del vendedor.
  const esVentaPresencial = esRecorridoDeVendedor(location.pathname, landingUrlCotizacion);

  const filtrarRutasLanding = (): { path: string; element: any }[] => {
    if (origen!.origen === "SEGURARSE") return rutas_landing;

    return rutas_landing.filter(route =>
      route.path === "/seguros-corporativos" ||
      origen!?.rutas.includes(route.path)
    );
  }

  const getRootElement = () => {
    if (!origen!.home_root) {
      return <Pymes />;
    }
    return <Home />;
  };


  const getPaisRouter = (): {
    path: string;
    element: any
  }[] => {
    switch (config!.pais) {
      case "AR":
        return routes_arg;
      case "UY":
        return routes_uy;
      case "BR":
        return [];
      default:
        return [];
    }
  };


  return (
    <>
      <Routes>
        <Route path="/" element={getRootElement()} />

        {/*Landings BASE */}

        <Route path="/sustentabilidad" element={<Sustentabilidad />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/preguntas-frecuentes" element={<PreguntasFrecuentes />} />
        <Route path="/politicas-privacidad" element={<PoliticasPrivacidad />} />
        <Route path="/formulario-arrepentimiento" element={<FormularioArrepentimiento />} />
        <Route path="/quienes-somos" element={<QuienesSomos />} />
        <Route path="/nuestro-oneteam" element={<OneTeam />} />
        <Route path="/formulario-arrepentimiento-enviado" element={<FormularioArrepentimientoEnviado />} />
        {/* Landings de clientes (link con token). Apagado salvo landings_enabled en react_config.json */}
        <Route
          path="/gestion/*"
          element={
            <Suspense fallback={<div className="d-flex justify-content-center py-5"><div className="spinner-border" role="status" /></div>}>
              <GestionApp />
            </Suspense>
          }
        />
        {/* Precios guardados por mail (link con token). Apagado salvo retomar_enabled en react_config.json */}
        <Route
          path="/retomar/*"
          element={
            <Suspense fallback={<div className="d-flex justify-content-center py-5"><div className="spinner-border" role="status" /></div>}>
              <RetomarApp />
            </Suspense>
          }
        />
        <Route path='*' element={<Redirect />} />
        {
          //Landing Indiviudos y Pymes
          filtrarRutasLanding().map(ruta => (
            <Route key={ruta.path} path={ruta.path} element={ruta.element} />
          ))
        }
        {/*Multicotizador */}
        {/*<Route path="/cotizador-de-seguros-celular" element={<MultiCotizador rubro={"celular"} />} />
          <Route path="/resultado-del-cotizador-de-celular" element={<MultiCotizador rubro={"celular"} resultados={true} />} />*/}
        <Route path="/cotizador-de-seguros-integral-de-comercio" element={<MultiCotizador rubro={"integral-de-comercio"} />} />
        <Route path="/resultado-del-cotizador-de-integral-de-comercio" element={<MultiCotizador rubro={"integral-de-comercio"} resultados={true} />} />
        <Route path="/:rubroURL/" element={<RubroOCompania pais={config!.pais} />} />
        <Route path="/:rubroURL/cotizacion/:tipoPersona?">
          <Route index element={<MultiCotizador />} />
          <Route path=":stepId/:compania?" element={<MultiCotizador />} />
        </Route>

        {/*Formularios */}
        <Route path="/siniestros/vehiculos" element={<Siniestros step={0} subStep={0} />} />
        <Route path="/siniestros/vehiculos/tipo-siniestro" element={<Siniestros step={1} subStep={0} />} />
        <Route path="/siniestros/vehiculos/formulario" element={<Siniestros step={2} subStep={0} />} />
        <Route path="/siniestros/vehiculos/formulario/terceros" element={<Siniestros step={2} subStep={1} />} />

        {/* Rutas dinámicas por país */}
        {getPaisRouter().map(route => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
        <Route path="/:rubro/error" element={<NotFound />} />
      </Routes >
      {/* /gestion y /retomar tienen marca por origen: el FAB de Segurarse no va (ni en marcas blancas). */}
      {!esGestion && !location.pathname.startsWith("/retomar") && !esVentaPresencial && <WhatsAppFAB />}
    </>
  );
};



const Redirect = () => {
  const params = useParams();

  useEffect(() => {
    if (params['*'] === '') {
      window.location.reload();
    } else {
      window.location.href = window.location.origin;
    }
  }, [])

  return <></>
}